import { Injectable } from '@angular/core';
import {
  AuthService,
  EventService,
  GlobalMessageService,
  GlobalMessageType,
  LogoutEvent,
  RoutingService,
} from '@spartacus/core';
import { take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LogoutService {
  constructor(
    protected routingService: RoutingService,
    protected authService: AuthService,
    private globalMessageService: GlobalMessageService,
    protected eventService: EventService
  ) {}

  logout(): void {
    this.authService.logout();
    this.eventService
      .get(LogoutEvent)
      .pipe(take(1))
      .subscribe(() => {
        this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_CONFIRMATION);
      });
  }
}
